import { imagesUrl } from '../resources.js';
import common from '../common/common.js';
//import store from '../store/index.js'

async function createImageForItem(itemId, restaurantName, image) {
    let containerName = restaurantName;
    containerName = containerName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/uploadimageforitem/${containerName}/${itemId}`;
    console.log('createImageForItem')
    return await common.postFile(url, image);
} 

async function createImageForRestaurant(restaurantId, image) {
    let url = `${imagesUrl}/uploadimageforrestaurant/${restaurantId}`;
    return await common.postFile(url, image);
}

async function deleteImageForItem(itemId, restaurantName) {

    let containerName = restaurantName.replace(/\s/g,'').toLowerCase();
    let url = `${imagesUrl}/deleteimageforitem/${containerName}/${itemId}`;
    return await common.deleteData(url);
}

async function deleteImageForRestaurant(restaurantId) {
    let url = `${imagesUrl}/deleteimageforrestaurant/${restaurantId}`;
    return await common.deleteData(url); 
}



export default {
    createImageForItem,
    createImageForRestaurant,
    deleteImageForItem,
    deleteImageForRestaurant
} 